import { BaseApi } from '@/services/api/base-api.ts';
import { z } from 'zod';
import zodCompanyCalendarDayDto from '@/schemas/company/zod-CompanyCalendarDayDto.js';
import zodCompanyCalendarBusinessDayDto from "@/schemas/company/zod-CompanyCalendarBusinessDayDto.js";

export type CompanyCalendarDayDto = z.infer<typeof zodCompanyCalendarDayDto>;
export type CompanyCalendarBusinessDayDto = z.infer<typeof zodCompanyCalendarBusinessDayDto>;

export class CompanyCalendarDayApi extends BaseApi {
  constructor() {
    super();
  }

  async listAsync(yearMonth: string) {
    return this.requestAsync({
      schema: z.array(zodCompanyCalendarDayDto), // 배열
      url: `company/calendar/month/${yearMonth}/day`,
    });
  }

  async businessDayCountAsync(yearMonth: string) {
    return this.requestAsync({
      schema: zodCompanyCalendarBusinessDayDto,
      url: `company/calendar/month/${yearMonth}/businessDay`,
    })
  }
}
